import api from './client';
import type {
  ApiResponse,
  LoginRequest,
  LoginResponse,
  UserMe,
} from '@/types';

export const authApi = {
  login: (data: LoginRequest) =>
    api.post<ApiResponse<LoginResponse>>('/auth/login/', data),

  logout: (refresh: string) =>
    api.post<ApiResponse>('/auth/logout/', { refresh }),

  refresh: (refresh: string) =>
    api.post<ApiResponse<{ access: string; refresh: string }>>('/auth/refresh/', { refresh }),

  me: () => api.get<ApiResponse<UserMe>>('/auth/me/'),

  requestPasswordReset: (email: string) =>
    api.post<ApiResponse>('/auth/password-reset/', { email }),

  confirmPasswordReset: (token: string, new_password: string) =>
    api.post<ApiResponse>('/auth/password-reset/confirm/', { token, new_password }),

  changePassword: (current_password: string, new_password: string) =>
    api.post<ApiResponse>('/auth/change-password/', { current_password, new_password }),

  updateEmailPreferences: (prefs: { morning?: boolean; evening?: boolean }) =>
    api.patch<ApiResponse<{ email_prefs: Record<string, boolean> }>>(
      '/auth/email-preferences/', prefs,
    ),

  impersonate: (userId: string) =>
    api.post<ApiResponse<LoginResponse>>(`/auth/impersonate/${userId}/`),

  endImpersonation: () =>
    api.post<ApiResponse>('/auth/impersonate/end/'),
};
